/**
 * useBoscoCaptureAccess — single source of truth for entitlement.
 *
 * Mirrors the BOSCO Studio access hook conventions:
 *   loading | error | data { enabled, dormant, tier, isIndividual, ... }
 */

import { useEffect, useRef, useState } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';
const TOKEN_KEY = 'sip_token';

export function useBoscoCaptureAccess({ enabled = true } = {}) {
  const [state, setState] = useState({ loading: true, data: null, error: null });
  const fetched = useRef(false);

  useEffect(() => {
    if (!enabled || fetched.current) return;
    fetched.current = true;
    const token = (typeof window !== 'undefined' && localStorage.getItem(TOKEN_KEY)) || '';
    if (!token) {
      setState({ loading: false, data: null, error: 'no-token' });
      return;
    }
    (async () => {
      try {
        const r = await fetch(`${API_URL}/api/bosco-capture/access`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!r.ok) {
          setState({ loading: false, data: null, error: `status-${r.status}` });
          return;
        }
        const data = await r.json();
        setState({ loading: false, data, error: null });
      } catch (e) {
        setState({ loading: false, data: null, error: e.message || 'fetch-failed' });
      }
    })();
  }, [enabled]);

  return state;
}
